var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot-wrapper "},[_c('span',[_vm._v("灵宝诚田网络科技有限公司")]),_c('span',[_vm._v("豫ICP备20017470号")])])}]

export { render, staticRenderFns }